import LoadsList from "modules/Checkin/components/LoadsList/LoadsList";

export default LoadsList;
